"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var generateKey_1 = require("./lib/generateKey");
function isOTPToken(token) {
    return typeof token === 'string'
        && /^[0-9]{6}$/.test(token); // e.g. "123456"
}
exports.isOTPToken = isOTPToken;
function isOTPKey(key) {
    // NOTE: yes this is strange, but it's how the standard is defined... >_>
    return typeof key === 'string'
        && /^[a-z2-7]{4}( [a-z2-7]{4}){7}$/.test(key); // e.g. "3434 4567 3434 4567 3434 4567 3434 4567"
}
exports.isOTPKey = isOTPKey;
function generateOTPKey(opts) {
    if (opts === void 0) { opts = {}; }
    var otpKey = generateKey_1.generateKey();
    var _a = opts.user, user = _a === void 0 ? 'Studio User' : _a, _b = opts.issuer, issuer = _b === void 0 ? 'ScreenCloud' : _b;
    if (!isOTPKey(otpKey)) {
        throw new Error("key is not a valid OTP Key");
    }
    var secret = otpKey.replace(/[\s._-]+/g, '').toUpperCase();
    // eslint-disable-next-line prefer-template
    var otpKeyUri = 'otpauth://totp/' + encodeURI(issuer) + ':' + encodeURI(user)
        + '?secret=' + secret
        + '&issuer=' + encodeURIComponent(issuer)
        + '&algorithm=SHA1&digits=6&period=30';
    return { otpKey: otpKey, otpKeyUri: otpKeyUri };
}
exports.generateOTPKey = generateOTPKey;
